<div class="admin-settings-container">
  <div class="page-header">
    <div>
      <h1 i18n="@@adminSettings.title">System settings</h1>
      <p class="subtitle" i18n="@@adminSettings.subtitle">
        Runtime key/value settings stored in the database. Empty values are unset.
      </p>
    </div>
    <p-button
      icon="pi pi-refresh"
      severity="secondary"
      [outlined]="true"
      [loading]="isLoading()"
      (click)="ngOnInit()"
      i18n-pTooltip="@@common.refresh"
      pTooltip="Refresh"
      tooltipPosition="top"
      i18n-ariaLabel="@@common.refresh"
      ariaLabel="Refresh">
    </p-button>
  </div>

  @if (isLoading()) {
    <div class="loading-container">
      <p-progressSpinner />
    </div>
  } @else {
    <p-table
      [value]="settings()"
      styleClass="settings-table"
      [tableStyle]="{ 'min-width': '50rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th i18n="@@adminSettings.col.key">Key</th>
          <th i18n="@@adminSettings.col.value">Value</th>
          <th i18n="@@adminSettings.col.updatedAt">Updated at</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-setting>
        <tr>
          <td><code>{{ setting.key }}</code></td>
          <td>
            @if (setting.value) {
              <code class="value-cell">{{ setting.value }}</code>
            } @else {
              <p-tag severity="secondary" i18n-value="@@adminSettings.empty" value="empty"></p-tag>
            }
          </td>
          <td>
            @if (setting.updated_at) {
              {{ setting.updated_at | date:'short' }}
            } @else {
              <span class="muted">—</span>
            }
          </td>
          <td>
            <p-button
              icon="pi pi-pencil"
              [text]="true"
              size="small"
              severity="secondary"
              i18n-pTooltip="@@common.edit"
              pTooltip="Edit"
              tooltipPosition="top"
              (click)="edit(setting)"
              i18n-ariaLabel="@@common.edit"
              ariaLabel="Edit">
            </p-button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="empty-message" i18n="@@adminSettings.emptyList">
            No settings.
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>

<p-drawer
  [visible]="drawerVisible()"
  (visibleChange)="drawerVisible.set($event)"
  position="right"
  [style]="{ width: '480px' }"
  [modal]="true"
  (onHide)="closeDrawer()">
  <ng-template pTemplate="header">
    <h2 class="drawer-title" i18n="@@adminSettings.drawer.title">Edit setting</h2>
  </ng-template>

  <div class="drawer-content">
    <div class="form-field">
      <label class="field-label" i18n="@@adminSettings.col.key">Key</label>
      <code class="key-readonly">{{ editingKey() }}</code>
    </div>

    <div class="form-field">
      <label for="setting-value" class="field-label" i18n="@@adminSettings.col.value">Value</label>
      <input
        pInputText
        id="setting-value"
        [ngModel]="editingValue()"
        (ngModelChange)="onValueInput($event)"
        i18n-placeholder="@@adminSettings.valuePlaceholder"
        placeholder="(leave empty to unset)"
        class="w-full" />
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="drawer-footer">
      <p-button
        severity="secondary"
        [outlined]="true"
        (click)="closeDrawer()"
        [disabled]="isSaving()"
        i18n-label="@@common.cancel"
        label="Cancel">
      </p-button>
      <p-button
        [icon]="isSaving() ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
        (click)="save()"
        [disabled]="isSaving()"
        [loading]="isSaving()"
        i18n-label="@@common.save"
        label="Save">
      </p-button>
    </div>
  </ng-template>
</p-drawer>
